import { Action } from "redux"

import * as actions from "./actions"

export const initialState: Tutorial.Tutorial = {
    loaded: false,
}

const handlers: {
    [action: string]: (
        state: Tutorial.Tutorial,
        props: Action,
    ) => Tutorial.Tutorial
} = {
    [actions.RECEIVE_CONTENT]: (
        state,
        { content }: actions.ReceiveContent,
    ): Tutorial.Tutorial => ({
        ...state,
        content,
        loaded: true,
    }),
}

export default function reducer(
    state = initialState,
    action: Action,
): Tutorial.Tutorial {
    const handler: (
        state: Tutorial.Tutorial,
        action: Action,
    ) => Tutorial.Tutorial = handlers[action.type]
    return handler ? handler(state, action) : state
}
